import Modal from '~/js/components/global/Modal';
import ModalLevels from './ModalLevels';
import ModalVillages from './ModalVillages';

const { PureComponent, Fragment } = window.React;

export class Filters extends PureComponent {
  getfilters = (section) => {
    const { accommodationsData, isDisabledByTab } = this.props;
    const filters = accommodationsData.reduce((currentFilters, accommodation) => {
      const newFilters = accommodation[section].reduce((filterArr, filter) => {
        const filterValue = this.getSectionFilter(section, filter);

        if(typeof filterValue !== 'undefined') {
          filterArr.push(filterValue);
        }

        return filterArr;
      }, []);
      let status = isDisabledByTab(accommodation);

      newFilters.forEach((filter) => {
        status = this.isFilterDisabled(filter, section) ? status : false;
        currentFilters[filter] = {name: filter, status: status || (filter in currentFilters && currentFilters[filter])};
      });

      return currentFilters;
    }, {});

    return {
      section,
      filters
    };
  }

  _renderFilterInput = ({ filters, section }) => {
    const { filterChange, selectedFilters } = this.props;
    const sectionSelectedFilters = selectedFilters[section];

    return (
      Object.keys(filters).map(key => {
        const filter = filters[key];
        const filterIsChecked = sectionSelectedFilters.includes(filter.name);

        return (
          <div className="filters" key={`${section}-${filter.name}`}>
            <div className="filter">
              <div className="checkbox-btn-wrapper ib xs-1">
                <input type="checkbox" id={filter.name} name={filter.name} value={filter.name} disabled={!filter.status} checked={filterIsChecked} onChange={e => filterChange(e, filter.name, section)}/>
                <label htmlFor={filter.name} className={`checkbox-btn ${filter.status ? '' : 'disabled'}`}/>
              </div>
              <div className="filter-name-container xs-11 lg-10 ib">
                <label htmlFor={filter.name} className={`filter-name lg-11 ${filter.status ? '' : 'disabled'}`}>{filter.name}</label>
              </div>
            </div>
          </div>
        );
      })
    );
  }

  removeRepeated = (filters) => {
    return filters.sort((filterA, filterB) => {
      if(filterA.name < filterB.name) {
        return -1;
      }
      if(filterA.name > filterB.name) {
        return 1;
      }

      return 0;
    }).reduce((uniqueArr, filter, index, filtersArr) => {
      if(!index || filter.name !== filtersArr[index - 1].name) {
        uniqueArr.push(filter);
      } else if(filter.status && !filtersArr[index - 1].status) {
        uniqueArr.pop();
        uniqueArr.push(filter);
      }

      return uniqueArr;
    }, []);
  }

  isFilterDisabled = (filter, section) => {
    const { filteredAccommodations } = this.props;

    const available = typeof filteredAccommodations.find(accommodation => {
      return typeof accommodation[section].find(currentFilter => {
        return this.getSectionFilter(section, currentFilter) === filter;
      }) !== 'undefined';
    }) !== 'undefined';

    return available;
  }

  getSectionFilter = (section, filter) => {
    const sectionFilter = {
      views: filter,
      amenities: filter.typeId === 1 ? filter.name : undefined,
      promotions: filter.title
    };

    return sectionFilter[section];
  }

  getGuestsFilter = () => {
    const { filteredAccommodations, selectedFilters } = this.props;
    const maxOccupants = filteredAccommodations.reduce((occupants, accommodation) => {
      const accommodationOccupants = accommodation.maxOccupants;

      return accommodationOccupants > occupants ? accommodationOccupants : occupants;
    }, 1);

    return (
      <div>
        <div className="occupants-select">
          {this.getOccupants(maxOccupants - selectedFilters.children, 1)}
          <span>Adults</span>
        </div>
        <div className="occupants-select children-filter">
          {this.getOccupants(maxOccupants - selectedFilters.adults, 0)}
          <span>Children</span>
        </div>
      </div>
    );
  }

  getOccupants = (maxOccupants, startValue) => {
    const occupants = [];
    for (let index = startValue; index <= maxOccupants; index++) {
      occupants.push(
        <option key={`${index === 1 ? 'Adult' : 'Children'}-${index}`} value={index}>
          {index}
        </option>
      );
    }
    
    let selectValue = startValue;
    if(sessionStorage.selectedFilters !== undefined) {
      let sessionStorageFilters = JSON.parse(sessionStorage.selectedFilters);
      selectValue = startValue === 1 ? sessionStorageFilters.adults : sessionStorageFilters.children;
    }
    
    return (
      <div className="control-wrapper custom-ddl select-container">
        <select value={selectValue} onChange={(e) => this.props.occupantsChange(e, startValue)}>
          {occupants}
        </select>
      </div>
    );
  }

  getVillageFilter = () => {
    const { accommodationsData, filteredAccommodations, villageChange, selectedFilters } = this.props;
    const villagesFilters = selectedFilters.villages;
    let villages = accommodationsData.reduce((villagesArr, accommodation) => {
      const status = (typeof filteredAccommodations.find(filteredAccommodation => {
        return filteredAccommodation.groupCode === accommodation.groupCode;
      }) !== 'undefined') && this.props.isDisabledByTab(accommodation);
      const village = {name: this.getVillageName(accommodation.groupCode), status: status, code: accommodation.groupCode, checked: false };

      if(typeof village.name !== 'undefined') {
        village.checked = villagesFilters.includes(village.code)
        villagesArr.push(village);
      }

      return villagesArr;
    }, []);

    villages = this.removeRepeated(villages);

    return (
      villages.map(village => {
        return (
          <div className="filters" key={`village-${village.name}`}>
            <div className="filter">
              <div className="checkbox-btn-wrapper ib lg-1">
                <input type="checkbox" id={village.code} name={village.code} checked={village.checked} disabled={!village.status} onChange={e => villageChange(e, village.code)}/>
                <label htmlFor={village.code} className={`checkbox-btn ${village.status ? '' : 'disabled'}`}/>
              </div>
              <div className="filter-name-container lg-10 ib">
                <label htmlFor={village.code} className={`filter-name lg-11 ${village.status ? '' : 'disabled'}`}>{village.name}</label>
              </div>
            </div>
          </div>
        );
      })
    );
  }

  getVillageName = (code) => {
    const villages = {
      KWV: 'Key West Village',
      BIT: 'Italian Village',
      BFV: 'French Village',
      BCV: 'Caribbean & Seaside Villages'
    };

    return villages[code];
  }

  getAllFilters = () => {
    const viewFilters = this._renderFilterInput(this.getfilters('views'));
    const amenityFilters = this._renderFilterInput(this.getfilters('amenities'));
    const promotionFilters = this._renderFilterInput(this.getfilters('promotions'));

    return (
      <Fragment>
        <div className="xs-12 lg-3 filter-box">
          <div className="filters-container">
            <div className="title">room view</div>
            <div className="filter-list">
              {
                viewFilters
              }
            </div>
          </div>
        </div>
        <div className="xs-12 lg-3 filter-box">
          <div className="filters-container">
            <div className="title">room features</div>
            <div className="filter-list">
              {
                amenityFilters
              }
            </div>
          </div>
        </div>
        <div className="xs-12 lg-3 filter-box">
          <div className="filters-container">
            <div className="title">room special offers</div>
            <div className="filter-list">
              {
                promotionFilters
              }
            </div>
          </div>
        </div>
        <div className="xs-12 lg-3 guest-filter-box">
          <div className="filter-box">
            <div className={`filters-container guest ${this.props.rstCode !== 'BTC' ? 'not-btc' : ''}`}>
              <div className="title guest">guests per room</div>
              {this.getGuestsFilter()}
            </div>
          </div>
          {this.props.rstCode === 'BTC' &&
          <div className="filter-box">
            <div className="filters-container village">
              <a href="#villages" className="js-magnific-popup">
                <div className="title">village <span className="icon-info" /></div>
              </a>
              <div className="filter-list">
                {this.getVillageFilter()}
              </div>
            </div>
          </div>}
        </div>
      </Fragment>
    );
  }

  noFiltersSelected = () => {
    const {selectedFilters: {
      views,
      amenities,
      promotions,
      villages,
      adults,
      children,
      updatingExistingFilters
    }} = this.props;

    return views.length === 0 && amenities.length === 0 && promotions.length === 0 && villages.length === 0 && adults === 1 && children === 0;
  }

  render() {
    return (
      <Fragment>
        <div  className="filter-box-container row  show-desktop">
          <div className="filters-header xs-12">
            <div className="lg-6 filter-by-container">
              <span className="filter-by">filter rooms by
              {!this.noFiltersSelected() &&
                <span className="reset" onClick={() => this.props.reset()}>reset <span className="icon-reset"/></span>
              }
              </span>
            </div>
            <div className="lg-6 about-container">
              <a href="#levels" className="js-magnific-popup">
                <span className="about">about Rooms & Suites Levels <span className="icon-info" /></span>
              </a>
            </div>
          </div>
          {this.getAllFilters()}
        </div>
        <div className="xs-12 about-container show-mobile">
          <a href="#levels" className="js-magnific-popup">
            <span className="about">about accommodation Levels <span className="icon-info" /></span>
          </a>
        </div>
        <Modal id="refine">
          <div className="xs-12 filter-by-container">
            <span className="filter-by">filter rooms by
            {!this.noFiltersSelected() &&
              <span className="reset" onClick={() => this.props.reset()}>reset <span className="icon-reset"/></span>
            }
            </span>
          </div>
          {this.getAllFilters()}
        </Modal>
        <ModalLevels />
        <ModalVillages />
      </Fragment>
    );
  }
}

export default Filters;
